import { render, staticRenderFns } from "./CierreGuiaManual.vue?vue&type=template&id=824aa4fc"
import script from "./CierreGuiaManual.vue?vue&type=script&lang=js"
export * from "./CierreGuiaManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports